import { SigninForm } from 'features/auth/components/signin-form';
import darklogo from 'assets/images/bebrave-group-dark.svg';
import lightlogo from 'assets/images/bebrave-group.svg';
import { useTheme } from 'components/core/theme-provider';
import { useGetLoginOptions } from 'features/auth/hooks/use-auth';
import { LoadingOverlay } from 'components/core/loading-overlay';
import { useCommonStore } from 'state/store/common/useCommonStore';
import { useTranslation } from 'react-i18next';
import { Link, useSearchParams } from 'react-router-dom';
import { useConfigStore } from 'state/store/config/useConfigStore';
import { useWhiteLabelStore } from 'state/store/white-label';
import { useMobileDeepLink } from 'hooks/use-mobile-deep-link';
import { MobileDeepLinkLoader } from 'components/core/mobile-deep-link-loader';
import { useEffect, useState } from 'react';

export function SigninPage() {
  const [searchParams] = useSearchParams();
  const code = searchParams.get('code') ?? '';
  const state = searchParams.get('state') ?? '';
  const INVITE_PREFIX = "/group-invite/";
  const goto = searchParams.get("goto"); // encoded
  const inviteToken = goto && decodeURIComponent(goto).startsWith(INVITE_PREFIX)
      ? decodeURIComponent(goto).replace(INVITE_PREFIX, "")
      : null;
  const { t } = useTranslation();
  const { theme } = useTheme();
  const { data: loginOption, isLoading } = useGetLoginOptions();
  const setUser = useCommonStore((state) => state.setUser);
  const { configurationSettings } = useConfigStore();
  const [showWebUi, setShowWebUi] = useState(false);

  const { settings: whiteLabelSettings } = useWhiteLabelStore();

  // Determine which logo to use based on theme and white-label settings
  const logoSrc = theme === 'dark'
    ? (whiteLabelSettings?.logoUrlDarkMode || darklogo)
    : (whiteLabelSettings?.logoUrl || lightlogo);

  const deepLinkUrl = `${process.env.REACT_APP_PUBLIC_MOBILE_BUNDLE_ID}://login/?code=${code}&state=${state}&token=${inviteToken}`;
  const { isMobile } = useMobileDeepLink({
    deepLinkUrl,
    fallbackDelay: 2000,
  });

  useEffect(() => {
    setShowWebUi(!isMobile);
    setTimeout(() => {
      setShowWebUi(true);
    }, 5000);
  }, [isMobile]);

  setUser(null);

  if (isLoading) {
    return <LoadingOverlay />;
  }

  const isEmailSignUpEnabled = configurationSettings?.paths?.emailSignUpEnabled ?? false;

  return showWebUi ? (
    <div className="flex flex-col gap-6 w-[90%]">
      <div className="w-40">
        <img src={logoSrc} onError={(e) => {
          const target = e.target as HTMLImageElement;
          if (target.src !== logoSrc) {
            target.src = lightlogo;
          }
        }} className="h-10 object-contain" alt="logo" />
      </div>
      {isEmailSignUpEnabled && <div>
        <div className="text-2xl font-bold text-high-emphasis">{t('LOG_IN')}</div>
        <div className="flex items-center gap-1 mt-1">
          <span className="text-sm font-normal text-medium-emphasis">{t('DONT_HAVE_ACCOUNT')}</span>
          <Link
            to={'/signup'}
            className="text-sm font-bold text-primary hover:text-primary-600 hover:underline"
          >
            {t('SIGN_UP')}
          </Link>
        </div>
      </div>}
      {/*  <div className="w-full invisible h-0 ">
        <div className="rounded-lg bg-success-background border border-success p-4">
          <p className="text-xs font-normal text-success-high-emphasis">
            <span className="font-semibold">demo.construct@seliseblocks.com</span> with password:{' '}
            <span className="font-semibold">H%FE*FYi5oTQ!VyT6TkEy</span>
          </p>
        </div>
      </div> */}

      {loginOption && (
        <SigninForm
          loginOption={{
            ...loginOption,
          }}
        />
      )}

      <div className="flex items-center justify-center gap-3 text-xs text-medium-emphasis">
        <a
          href="https://eaglegpt.ai/en/term-of-conditions/"
          target="_blank"
          rel="noreferrer"
          className="text-primary hover:text-primary-600 hover:underline"
        >
          {t('TERMS_OF_SERVICE')}
        </a>
        <span className="text-primary">•</span>
        <a
          href="https://eaglegpt.ai/en/privacy-policy/"
          target="_blank"
          rel="noreferrer"
          className="text-primary hover:text-primary-600 hover:underline"
        >
          {t('PRIVACY_POLICY')}
        </a>
      </div>
    </div>
  ) : (
    <MobileDeepLinkLoader />
  );
}
